"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_EVENTS_DETAIL = exports.DATA_EVENTS_CONTAINER = exports.DATA_EVENTS = void 0;
// Events
exports.DATA_EVENTS = 'data-events';
exports.DATA_EVENTS_CONTAINER = 'data-events-container';
exports.DATA_EVENTS_DETAIL = 'data-events-detail';
